import React, { useEffect, useState } from "react";
import Button from "../../components/FormComponents/Button";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { useTableContext } from "../../context/TableContext";
import { getDefaultConfig } from "../../utils/Config/getDefaultConfig";
import { getPositionedElementConfig } from "../FlexibleLayout/utils";
import { tableTypeNameMapping } from "../../constant/nameMapping";
import axiosInstance, { handleApiError } from "../../services/axiosService";

const initialBlockData = {
  block_name: "",
  table_type: "",
  table_id: "",
  activity_id: "",
  is_positioned_block: true
};
const initialErrorData = {
  name: "",
  device: "",
  table_type: "",
  table_id: "",
  activity_id: "",
  type: ""
};

const ModalOfApplicationBlockCreation = ({ insertPopupData, insertDataAndUpdateTree, pageData, isScreen = false }) => {
  const [newBlockData, setNewBlockData] = useState(initialBlockData);
  const [validationError, setValidationError] = useState(initialErrorData);

  const [allTable, setAllTable] = useState([]);
  const [selectedTypeTables, setSelectedTypeTables] = useState([]);
  const { tableData, rdbmsData } = useTableContext();
  const [selectedActivityArray, setSelectedActivityArray] = useState([]);
  const [allRecordviewTemplates, setAllRecordviewTemplates] = useState([]);
  const [allPostgresTemplate, setAllPostgresTemplate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handelTypeChange = (type) => {
    if (type === "rdbms") {
      setSelectedTypeTables(rdbmsData);
    } else if (type === "appuser") {
      setSelectedTypeTables([
        {
          table_name: "Appuser",
          id: "appuser"
        }
      ]);
    }
    // else if (type === "communityuser") {
    //   setSelectedTypeTables([
    //     {
    //       table_name: "CommunityUser",
    //       id: "communityuser"
    //     }
    //   ]);
    // }
    else if (type === "RvTemplate") {
      setSelectedTypeTables(allRecordviewTemplates);
    } else if (type === "postgres") {
      setSelectedTypeTables(allPostgresTemplate);
    } else if (type === "activity") {
      const data = allTable.filter((table) => table.table.table_type === "statemachine");
      setSelectedTypeTables(data);
    } else {
      const data = allTable.filter((table) => table.table.table_type === type);
      setSelectedTypeTables(data);
    }
    setNewBlockData({ ...newBlockData, table_type: type, table_id: "" });
  };

  const handleTableChange = (value) => {
    setNewBlockData({ ...newBlockData, table_id: value });
  };
  const handleIsOfflineChange = (value) => {
    setNewBlockData({ ...newBlockData, is_offline: value });
  };

  const handlePositionedScreenChange = (e) => {
    setNewBlockData({ ...newBlockData, is_positioned_block: e.target.checked });
  };

  const createApplicationBlock = async () => {
    const { name, parentData } = insertPopupData;
    const { data, error } = getFullConfigOfAppBlockCreator(
      name,
      parentData,
      newBlockData.block_name,
      newBlockData.table_type,
      newBlockData.is_offline || false,
      newBlockData.is_positioned_block || false,
      newBlockData.table_id,
      newBlockData.activity_id,
      newBlockData.instance_field
    );
    if (error) {
      setValidationError(error);
      return;
    }
    setIsLoading(true);
    await insertDataAndUpdateTree(insertPopupData, data);
    setIsLoading(false);
  };

  const fetchRecordviewTemplates = async () => {
    try {
      const { data } = await axiosInstance.get("/recordview-template");
      setAllRecordviewTemplates(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  const fetchPostgresTemplates = async () => {
    try {
      const { data } = await axiosInstance.get("/postgres");
      setAllPostgresTemplate(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  const returnRdbmsFields = () => {
    const rdbms = rdbmsData.find((rbdms) => rbdms.id === newBlockData.table_id);
    return rdbms.fields || [];
  };

  useEffect(() => {
    if (!newBlockData.table_id) return;
    const SM = tableData.find((table) => table.state_machine_id === newBlockData.table_id);
    if (!SM) return;
    const activitiesArray = SM.table.columns_new.filter((col) => col.type === "activity");
    if (insertPopupData.name === "activitycard" || newBlockData.table_type === "activity") {
      setSelectedActivityArray(activitiesArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insertPopupData.name, newBlockData.table_id, tableData, newBlockData.table_type]);

  useEffect(() => {
    setAllTable(tableData);
    if (isScreen) {
      setNewBlockData({
        ...newBlockData,
        table_type: pageData.page,
        table_id: pageData.pageId
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (insertPopupData.name === "recordsview" || insertPopupData.name === "chart") {
        await fetchRecordviewTemplates();
        await fetchPostgresTemplates();
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderBlockOptions = (name) => {
    let options = [];

    switch (name) {
      case "activitycard":
        options = ["statemachine"];
        break;
      case "recordsview":
        options = [
          "entity",
          "statemachine",
          "activity",
          "rdbms",
          "postgres",
          "appuser",
          //  "communityuser",
          "RvTemplate"
        ];
        break;
      case "pivotcharts":
        options = ["entity", "statemachine", "activity", "rdbms", "postgres", "appuser", "RvTemplate"];
        break;
      case "chart":
        options = ["entity", "statemachine", "activity", "rdbms", "appuser"];
        break;
      case "detailsview":
        options = ["entity", "statemachine", "rdbms", "appuser"];
        break;
      case "progress-bar":
        options = ["statemachine"];
        break;
      default:
        options = ["entity", "statemachine"];
        break;
    }

    // Mapping object to rename the `name` while keeping `id` unchanged

    // Apply name mapping while keeping id unchanged
    const objOptions = options.map((option) => ({
      id: option,
      name: tableTypeNameMapping(option) || option // Use mapped name, fallback to original if not found
    }));

    return (
      <SingleSelectBox
        label="Select Type"
        selectedData={newBlockData.table_type}
        options={objOptions}
        onChange={(obj) => handelTypeChange(obj.id)}
        placeholder="Select type"
        error={validationError.tableType}
        isSearch={true}
      />
    );
  };

  const getOptions = (type, tables) => {
    return tables.map((table) => {
      const isStateMachineOrEntity = type === "statemachine" || type === "entity" || type === "activity";
      const isRecordViewTemplate = type === "RvTemplate";
      const value = isStateMachineOrEntity ? table.table.id : table.id;
      const displayName = isStateMachineOrEntity
        ? table.table.table_name
        : isRecordViewTemplate
          ? table.name
          : table.table_name;

      return {
        id: value,
        name: displayName
      };
    });
  };
  return (
    <>
      <div className="builder_form">
        <Input
          type="checkbox"
          label="WYSIWYG screen"
          name="is_positioned_screen"
          checked={newBlockData.is_positioned_block}
          onChange={handlePositionedScreenChange}
          containerClassName="d_flex justify_start"
        />

        {insertPopupData.name === "recordsview" && (
          <Input
            type="checkbox"
            containerClassName="d_flex justify_start"
            label="Offline"
            name="is_offline"
            checked={newBlockData.is_offline}
            onChange={(e) => handleIsOfflineChange(e.target.checked)}
          />
        )}
        <Input
          label="Name"
          error={validationError.name}
          value={newBlockData.block_name}
          onChange={(e) => setNewBlockData({ ...newBlockData, block_name: e.target.value })}
        />
        {!isScreen && (
          <>
            {insertPopupData.name !== "queryblocks" && renderBlockOptions(insertPopupData.name)}
            {newBlockData.table_type !== "" && (
              <SingleSelectBox
                selectedData={newBlockData.table_id}
                options={getOptions(newBlockData.table_type, selectedTypeTables)}
                onChange={(obj) => handleTableChange(obj.id)}
                placeholder="Select table"
                label={`Select ${tableTypeNameMapping(newBlockData.table_type)}`}
                error={validationError.tableId}
                isSearch={true}
              />
            )}
            {(insertPopupData.name === "activitycard" || newBlockData.table_type === "activity") &&
              newBlockData.table_id && (
                <SingleSelectBox
                  selectedData={newBlockData.activity_id}
                  options={selectedActivityArray}
                  valueKey="activity_id"
                  onChange={(obj) => setNewBlockData({ ...newBlockData, activity_id: obj.activity_id })}
                  placeholder="Select activity"
                  label="Select Activity"
                  error={validationError.activityId}
                  isSearch={true}
                />
              )}
            {insertPopupData.name === "detailsview" && newBlockData.table_type === "rdbms" && newBlockData.table_id && (
              <SingleSelectBox
                selectedData={newBlockData.instance_field}
                options={returnRdbmsFields()}
                valueKey="name"
                onChange={(obj) => setNewBlockData({ ...newBlockData, instance_field: obj.name })}
                placeholder="Select field"
                label="Instance Id Field"
              />
            )}
          </>
        )}
        {validationError.type && <ErrorMessage>{validationError.type}</ErrorMessage>}

        {(insertPopupData.name === "queryblocks" || newBlockData.table_id !== "") && (
          <Button onClick={createApplicationBlock} isLoading={isLoading}>
            Create
          </Button>
        )}
      </div>
    </>
  );
};

const getFullConfigOfAppBlockCreator = (
  type,
  device,
  blockName,
  tableType,
  isOffline,
  isPositionedBlock,
  tableId,
  activityId,
  instance_field
) => {
  let config;
  let error = null;

  if (blockName.trim() === "" || blockName.trim().length < 3) {
    error = { name: "Minimum 3 character required" };
  }

  if (!device) {
    error = { ...error, device: "Device is required" };
  }

  const validateConfig = () => {
    switch (type) {
      case "queryblocks":
        break;
      case "activitycard":
        if (!tableType) {
          error = { ...error, table_type: "Table type is required" };
        }
        if (!tableId) {
          error = { ...error, table_id: "Table ID is required" };
        }
        if (!activityId) {
          error = { ...error, activity_id: "Activity ID is required" };
        }
        break;
      default:
        if (!tableType) {
          error = { ...error, table_type: "Table type is required" };
        }
        if (!tableId) {
          error = { ...error, table_id: "Table ID is required" };
        }
        if (tableType === "activity" && !activityId) {
          error = { ...error, activity_id: "Activity ID is required" };
        }
        break;
    }
  };

  validateConfig();

  if (error) {
    return { config: null, error };
  }

  const configure = () => {
    switch (type) {
      case "recordsview":
        if (device === "desktop" || device === "tablet") {
          config = getDefaultConfig("recordview_desktop");
        } else if (device === "mobile") {
          config = getDefaultConfig("recordview_mobile");
        }
        config.table_type = tableType;
        config.is_offline = isOffline;
        config.config.layout.table_id = tableId;
        if (tableType === "activity") {
          config.config.layout.activity_id = activityId || "";
        }
        break;

      case "pivotcharts":
        config = getDefaultConfig("pivotcharts");
        config.table_type = tableType;
        config.config.layout.table_id = tableId;
        break;

      case "queryblocks":
        config = getDefaultConfig("queryblocks");
        break;

      case "chart":
        config = getDefaultConfig("chart");
        config.config.table_id = tableId;
        config.table_type = tableType;
        if (tableType === "activity") {
          config.config.activity_id = activityId || "";
        }
        break;

      case "progress-bar":
        config = getDefaultConfig("progress-bar");
        config.config.table_id = tableId;
        config.table_type = tableType;
        break;

      case "detailsview":
        config = getDefaultConfig("detailsview");
        config.table_type = tableType;
        config.data.table_id = tableId;
        if (tableType === "rdbms") {
          config.data.instance_field = instance_field;
        }
        break;

      case "activitycard":
        config = getDefaultConfig("detailsview");
        config.table_type = tableType;
        config.data.table_id = tableId;
        config.data.activity_id = activityId;
        config.data.config = {
          allow_activity_history: false,
          non_perform_activity_message: ""
        };
        break;

      default:
        error = { ...error, type: "Unknown block type" };
        break;
    }
  };

  configure();

  if (error) {
    return { config: null, error };
  }

  config.name = blockName;
  config.device = device;
  config.is_positioned_block = isPositionedBlock;

  if (isPositionedBlock) {
    setPositionedBlock(config, device);
  }
  return { data: config, error };
};

const setPositionedBlock = (config, device) => {
  config.is_positioned_block = true; // NOTE: Remove this after the new screen is ready
  config.position_block_config = [];
  const addDefaultSection = getPositionedElementConfig("section");
  config.position_block_config.push(addDefaultSection);
  if (device === "mobile") {
    config.position_block_metadata = {
      total_grid: 128,
      grid_size: 4
    };
  }
};

export default ModalOfApplicationBlockCreation;
